<template>
<div class="form">
  <!-- <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs> -->
  <v-card>
    <v-card-title class="text-h5 grey lighten-5">
    <v-breadcrumbs :items="item">
       <template v-slot:item="{ item }">
       <v-breadcrumbs-item
          :href="goToRoute(item.href)"
          :disabled="item.disabled"
        >
        {{ item.text }}
        </v-breadcrumbs-item>
      </template>
    </v-breadcrumbs>
    </v-card-title>
  </v-card>

<v-card>
      <v-card-title class="text-h5 grey lighten-2">
        {{ $t("modultangkapandataBlok7") }}
      </v-card-title>

      <v-container>
        <v-form ref="formblok7">
          <v-row>
            <v-col cols="12" sm="6">
              <v-text-field
                v-bind:label="$t('hid')"
                outlined
                dense
                v-model="blok7hid"
                :disabled="true"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="2">
              <v-text-field
                v-bind:label="$t('ps')"
                v-model="blok7pusingan"
                outlined
                dense
                :disabled="true"
              ></v-text-field>
            </v-col>
          </v-row>


          <v-card-text>
            <v-simple-table 
            fixed-header
            dense>

              <thead>
                <tr>
                  <th>
                    HARI
                  </th>

                  <th>
                    JUMLAH E-DAGANG
                  </th>

                  <th>
                    JUMLAH KESELURUHAN
                  </th>

                  <th>
                    AMAUN KUMULATIF
                  </th>

                  <!-- <th>
                    CATATAN
                  </th>   -->
                </tr>
              </thead>

              <tbody>
                
                <!-- 1hb -->

<!-- INCS01 -->
        <tr v-for="(value, date) in sortedData" :key="date">

          <td>
            {{date}}
          </td>

          <!-- <td>{{totalTarikh}}</td> -->

          <td>
            {{calculateEdagang(date)}}
          </td>

          <!-- <td>{{totalTarikh}}</td> -->

          <td>
            {{calculateRMHQ(date)}}
          </td>

          <!-- <td>{{totalRMHQ}}</td> -->

          <td>
            <a v-for="item in culmulativeArray" :key="item.date">
              <strong v-if="item.date == date">
              {{item.culmulative}}
              </strong>
            </a>
          </td>

          <!-- <td>
            <v-btn
                elevation="2"
                color="error"
                x-small
                @click="handleClick(date,blok7hid)"
              >Padam
            </v-btn>
          </td> -->


        </tr>

               



              </tbody>
            </v-simple-table>
          </v-card-text>
      
        </v-form>
      </v-container>
</v-card>


<!-- V-dialog  -->
  <v-dialog
      v-model="deleteDialog"
      max-width="290"
    >
      <v-card>
        <v-card-title class="text-h5 red--text">
          PADAM
        </v-card-title>

        <v-card-text>
           <strong>Semua pengisian pada tarikh ini akan dipadam.<br><br>
           Andakah anda pasti ingin meneruskan?</strong>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="#FAEF00"
            text
            @click="deleteDialog = false"
          >
            Batal
          </v-btn>

          <v-btn
            color="#FA0000"
            text
            @click="deleteData()"
          >
            Teruskan
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

</div>
</template>
<script>
import axios from "../../plugins/axios";
import i18n from "@/i18n";

/////////////////////////////////////////////////////////
import HES from '@/services/HES'
const HESservices= new HES();

import getLocalStorage from '@/services/getLocalStorage'
const localStorageData = new getLocalStorage();
    
export default {
    Name: "Blok7",
    
    data: () => ({

        deleteDialog: false,

        blok7hid: "",
        blok7pusingan: "",
        summaryData:[],
        sortedData:[],
        culmulativeArray: [],
        dateToDelete:'',
        hidToDelete:'',
        
      item: [
      {
        text: "Paparan Utama",
        disabled: false,
        href: "paparanutama",
      },
      {
        text: "BLOK 3 (PreCode)",
        disabled: false,
        href: "BLK3PreCode",
      },
      {
        text: "BLOK 3",
        disabled: false,
        href: "blk3",
      },
      {
        text: "BLOK 4a",
        disabled: false,
        href: "Blok4a",
      },
      {
        text: "BLOK 4b",
        disabled: false,
        href: "Blok4b",
      },
      {
        text: "BLOK 4c",
        disabled: false,
        href: "Blok4c",
      },
      {
        text: "BLOK 7",
        disabled: true,
        href: "blk7",
      },
      {
        text: "BLOK 7 (Imbangan)",
        disabled: false,
        href: "Blok7Imbangan",
      },
       {
        text: "Pengesahan (Imbangan)",
        disabled: false,
        href: "PengesahanImbangan",
      },
      ],
    
    }),
      mounted() {
        this.paparanpermulaan();
        // this.tambahcatatan = ".";
     },
    methods: {
      goToRoute(url) {
      return `/${i18n.locale}/${url}/${this.$route.params.hid}`;
      },

      validate () {
        this.$refs.form.validate()
      },
      reset () {
        this.$refs.form.reset()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },

       async paparanpermulaan() {
          try {
            if (typeof this.$route.params.hid !== "undefined") {
              await axios
                .get(
                  `${process.env.VUE_APP_API_URL}/auth/decode?de=${this.$route.params.hid}`
                )
                .then((result) => {
                  this.blok7hid = result.data.decode;
                  const jr2 = {
                    hidjr2: this.blok7hid,
                  };
                  axios
                    .post(`${process.env.VUE_APP_API_URL}/JR/papardatajr2`, jr2)
                    .then((res) => {
                      this.blok7hid = res.data.data.HID;
                      this.blok7pusingan = res.data.data.P;
                     //alert(this.blok7hid)
                    });
                    
                });
                //console.log(this.blok7hid)
                this.summaryData = await HESservices.getBlok7ByHID(this.blok7hid);
                await this.sortDataByDate(this.summaryData);
                this.calculateKumulatif();
            } else {
              this.$router.push(`/${i18n.locale}/heshid`, () => {});
            }
          } catch (err) {
            console.log(err);
            if (err.response.data.msg === "errordecode") {
              this.$router.push(`/${i18n.locale}/heshid`, () => {});
            }
          }
        },

      
      sortDataByDate(data){
        // this gives an object with dates as keys
        const groups = data.reduce((groups, game) => {
          
          let datez = new Date(game.Tarikh.split('T')[0]);
          // add a day
          var convDate = datez.setDate(datez.getDate() + 1);
  
          //const date = new Date(game.Tarikh.split('T')[0]);//ori


          const date = datez.toISOString().split('T')[0];

          if (!groups[date]) {
            groups[date] = [];
          }
          groups[date].push(game);
          this.sortedData = groups;
          return groups;
        }, {});

      },
      calculateEdagang(data){
        var total = 0;
        let jumEdagang = 0;
        for(var i = 0;i < this.sortedData[data].length ;i++){
          if(this.sortedData[data][i].eDagang == 1){
          jumEdagang = total + Number(this.sortedData[data][i].RMNEG);
          total = Number(jumEdagang.toFixed(2));
          }
        }
        return total;
      },
      
      calculateRMHQ(data){
        var total = 0;
        let jumRMNEG = 0;
        for(var i = 0;i < this.sortedData[data].length ;i++){
          jumRMNEG = total + Number(this.sortedData[data][i].RMNEG);
          total = Number(jumRMNEG.toFixed(2));
        }
        return total;
      },
      
      calculateKumulatif(data){
              var totalCulmulative = 0;
              let jumCulmulative = 0;
              for (var date in this.sortedData) {
                for(var i = 0; i < this.sortedData[date].length; i++){
                  jumCulmulative = Number(totalCulmulative) + Number(this.sortedData[date][i].RMNEG);
                  totalCulmulative = Number(jumCulmulative.toFixed(2));
                }
                this.culmulativeArray.push({"date":date,"culmulative":totalCulmulative})
              }
      },

      ccSum(data, condition){
        
        var r = [];
        r[0] = (this.sortedData[data][i])? data[0]: 0;  
        for(var i=1,l=this.sortedData[data][i].RMNEG; i<l; ++i) r[i] = r[i-1] + ( (this.sortedData[data][i])? data[i]: 0 );
        return r
      },

      handleClick(date,hid){
        this.dateToDelete = date;
        this.hidToDelete = hid;
        this.deleteDialog = true;
      },

      async deleteData(){
  
        var dataToDelete = {
          date: this.dateToDelete,
          hid: this.hidToDelete
        };

        try {

            await axios.post(`${process.env.VUE_APP_API_URL}/blk/deleteBlok7ByHID`,{dataToDelete})
            .then((result) => {
                if(result.data.status){
                  console.log("success")
                  this.deleteDialog = false;
                  this.reloadData();
                }else{
                  console.log("error")
                }
                  
            });
              
          } catch (err) {
            console.log(err)
          }
      },

      async reloadData(){
        this.summaryData = await HESservices.getBlok7ByHID(this.blok7hid);
        await this.sortDataByDate(this.summaryData);
        this.calculateKumulatif();
      }


    },

}
</script>

